import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';

@Component({
  selector: 'forgot-password',
  standalone: false,
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent extends BaseAuthComponent {
  title = 'Réinitialisation de mot de passe';
  description =
    'Renseigner le code de vérification et définir un nouveau mot de passe';
}
